import React from 'react';
import PropTypes from 'prop-types';

import * as ActPropTypes from 'types/act';

import SelectContactComponent from './SelectContactComponent';

export default function SelectContactContainer({
  eligibleFriends,
  ineligibleContacts,
  onSelectContact,
  selectedContactId,
}) {
  return (
    <SelectContactComponent
      eligibleFriends={eligibleFriends}
      ineligibleContacts={ineligibleContacts}
      onChange={onSelectContact}
      value={selectedContactId}
    />
  );
}

SelectContactContainer.propTypes = {
  eligibleFriends: PropTypes.arrayOf(ActPropTypes.eligibleFriend).isRequired,
  ineligibleContacts: PropTypes.arrayOf(ActPropTypes.ineligibleContact).isRequired,
  onSelectContact: PropTypes.func.isRequired,
  selectedContactId: PropTypes.number,
};

SelectContactContainer.defaultProps = {
  selectedContactId: undefined,
};